import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { Constants } from '@shared/services/constants';
import { SessionService } from '@shared/services/session.service';
import { CurrentDateInputModel } from '../shared/models/data/current-date-model';
import { CurrentDateOutputModel } from '../shared/models/data/current-date-model';

@Component({
  selector: 'aaos-app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss']
})
export class AdminPageComponent implements OnInit {

  actualDate: Date;
  currentDate: Date;
  hasDateBeenSet = false;
  formGroup: FormGroup;
  setDateControl = 'setDate';

  constructor(private enrollmentService: EnrollmentService, private sessionService: SessionService) {

  }

  ngOnInit() {
    this.createFormGroup();
    this.enrollmentService.getCurrentDate(this.sessionService.getMcid())
      .subscribe(x => {
        this.actualDate = x.actualDate;
        this.currentDate = x.currentDate;
        this.hasDateBeenSet = x.hasBeenSet;
      });
  }

  createFormGroup() {
    this.formGroup = new FormGroup({
      setDate: new FormControl('')
    });
  }

  setCurrentDate() {

    const dateModel = new CurrentDateInputModel();
    dateModel.id = this.sessionService.getMcid();
    dateModel.date = new Date(this.formGroup.controls[this.setDateControl].value);

    this.enrollmentService.setCurrentDate(dateModel)
      .subscribe(x => {
        this.actualDate = x.actualDate;
        this.currentDate = x.currentDate;
        this.hasDateBeenSet = x.hasBeenSet;
      });
  }

  clearCurrentDate() {

    const dateModel = new CurrentDateInputModel();
    dateModel.id = this.sessionService.getMcid();
    dateModel.date = new Date();

    this.enrollmentService.clearCurrentDate(dateModel)
      .subscribe(x => {
        this.actualDate = x.actualDate;
        this.currentDate = x.currentDate;
        this.hasDateBeenSet = x.hasBeenSet;
      });
  }

}
